import classNames from "classnames";
import React from "react";
import { Box } from "../shared";
import { colors } from "./constants";

export default function ChangeOnePartContent(props){

  const { stage, wordBreakdown, colorIndex, targetIndex, swapping, hidden, highlight, subIndex, assessmentMode, SUBS, isStart, versionId } = props;

  const NoOrthography = versionId === 2;

  const copBoxesClass = classNames({
    "change-one-part": true,
    "cop-boxes": true,
    hidden: hidden,
  });

  if (stage === 0) {
    return (
      <div className={copBoxesClass}>
        {wordBreakdown.map((grapheme, i) => {
          const widthOfBox = (100 / wordBreakdown.length).toFixed(2) + "%";
          const boxStyle = {
            background: highlight,
            minWidth: "80px",
            width: widthOfBox,
          }; // default the box to be yellow
          if (colorIndex >= i) boxStyle.background = colors.green; // change color to green when sounding out the phonemes
          return (
            <Box key={`0/${i}`} className="cop-box" style={boxStyle}>
              <div className="cop-letter">{NoOrthography ? "" : grapheme}</div>
            </Box>
          );
        })}
      </div>
    );
  }

  return (
    <div className={copBoxesClass}>
      {wordBreakdown.map((grapheme, i) => {
        const widthOfBox = (100 / wordBreakdown.length).toFixed(2) + "%";
        const boxStyle = {
          background: highlight,
          minWidth: "80px",
          width: widthOfBox,
        };
        let content = grapheme; // current letter in map
        let capBoxClass = classNames({
          "cop-box": true,
        });
        if (i === targetIndex) {
          // targetIndex = the start or the end index
          if (stage > 0) content = getSubLetter(SUBS[subIndex].word, isStart); // update the letter in (content)
          capBoxClass = classNames({
            "cop-box": true,
            swapping: swapping,
          });
        }
        if (!assessmentMode && colorIndex >= i)
          boxStyle.background = colors.green; // all green when colorIndex is set to -1
        return (
          <Box key={`0/${i}`} className={capBoxClass} style={boxStyle}>
            <div className="cop-letter">{NoOrthography ? "" : content}</div>
          </Box>
        );
      })}
    </div>
  );

}

function getSubLetter(word, isStart) {
  const index = isStart ? 0 : word.length - 1;
  return word[index];
}